import type { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCreateCompanyBankAccountRequestSchema,
  TCreateCompanyBankAccountResponseSchema,
} from "./createCompanyBankAccount.schema";

export const createCompanyBankAccount =
  (axios: IAxiosInstance) =>
  async (body: TCreateCompanyBankAccountRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TCreateCompanyBankAccountResponseSchema>
    >("/companies/bank", body);

    return response.data;
  };
